/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function BulkRemoveFolderDocumentsRequestFromJSON(json) {
    return BulkRemoveFolderDocumentsRequestFromJSONTyped(json, false);
}
export function BulkRemoveFolderDocumentsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        ids: json['ids']
    };
}
export function BulkRemoveFolderDocumentsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ids: value.ids
    };
}
